import React from 'react';
import { Backdrop, LoadingContainer } from './styled';

const Loading = () => (
  <>
    <Backdrop />
    <LoadingContainer>
      <div className="bouncer bounce1" />
      <div className="bouncer bounce2" />
      <div className="bouncer" />
    </LoadingContainer>
  </>
);

export default Loading;
